// Language flags switch by URL prefix (/en), which Shopify serves natively for published languages.
// Links are more reliable than the localization form POST, which fails in the local dev preview.
if (['localhost', '127.0.0.1'].includes(location.hostname)) {
  // Local preview only: allow English even while it is unpublished.
  const enablePreview = () => document.querySelectorAll('.kofea-language-switch__flag[aria-disabled="true"]').forEach((button) => {
    button.disabled = false;
    button.classList.remove('is-unavailable');
    button.removeAttribute('aria-disabled');
    button.setAttribute('aria-label', 'English');
    button.title = 'English';
  });
  enablePreview();
  new MutationObserver(enablePreview).observe(document.body, { childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'], subtree: true });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.kofea-language-switch__flag[name="language_code"]');
  if (!button || button.disabled) return;
  event.preventDefault();
  const path = location.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
  location.assign((button.value === 'en' ? '/en' + (path === '/' ? '' : path) : path) + location.search + location.hash);
});
